import { useEffect } from 'react';

// iOS / iPadOS — App Store, selain itu Play Store
function isAppleEnvironment() {
  const ua = navigator.userAgent || '';
  if (/iPhone|iPad|iPod/i.test(ua)) return true;
  if (typeof navigator !== 'undefined' && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return true;
  }
  return false;
}

export default function StoreRedirect({ appStoreUrl, playStoreUrl }) {
  useEffect(() => {
    const url = isAppleEnvironment() ? appStoreUrl : playStoreUrl;
    window.location.replace(url);
  }, [appStoreUrl, playStoreUrl]);

  return null;
}
